import { render, staticRenderFns } from "./dealerInfo.vue?vue&type=template&id=51ff23d6"
import script from "./dealerInfo.vue?vue&type=script&lang=js"
export * from "./dealerInfo.vue?vue&type=script&lang=js"
import style0 from "./dealerInfo.vue?vue&type=style&index=0&id=51ff23d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports